import React, { FC } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { useUIContext } from 'state/ui';

import { ButtonsContainer, CloseButton, Container, CookieNoticeLink, InfoText } from './styles';
import { ICookieBannerProps } from './types';

const CookieBanner: FC<ICookieBannerProps> = ({
  infoText,
  buttonText,
  link,
  handleAccept,
  handleClose
}) => {
  const { formatMessage } = useIntl();
  const { appFooterDimensions } = useUIContext();
  return (
    <Container $bottomInset={appFooterDimensions.height}>
      <InfoText>
        {infoText} <CookieNoticeLink href={link.href}>{link.text}</CookieNoticeLink>
      </InfoText>
      <ButtonsContainer>
        <CloseButton data-testid="close-cookies-button" onClick={handleClose}>
          {formatMessage(messages.closeCookies)}
        </CloseButton>
        <ActionButton
          data-testid="accept-all-cookies-button"
          variant={ActionButtonVariants.INVERSE}
          onClick={handleAccept}
        >
          {buttonText}
        </ActionButton>
      </ButtonsContainer>
    </Container>
  );
};

const messages = defineMessages({
  closeCookies: {
    id: 'closeCookies',
    defaultMessage: 'Close',
    description: 'Button to close the cookies banner'
  }
});

export { CookieBanner };
